import {Box, Typography} from "@mui/material";

export default function SessionReport({serviceType, countOfSessions, countOfSessionsWithPerformer}) {
    const totalSessionsText = `${countOfSessions} total session${countOfSessions !== 1 ? 's' : ''}`;
    const sessionsWithYouText = `${countOfSessionsWithPerformer} session${countOfSessionsWithPerformer !== 1 ? 's' : ''}`;

    return <Box style={{margin: '0.6rem'}}>
        <Typography variant="subtitle2" style={{fontWeight: 'bold', fontSize: '1rem'}}>{serviceType}</Typography>
        <Typography variant="body2" style={{marginBottom: '-0.2rem'}}>{totalSessionsText}</Typography>
        <Typography variant="body2">{sessionsWithYouText} with you</Typography>
    </Box>;
}